import React, { Component } from 'react';
import cookie from 'react-cookies'

export default class Header extends Component {
    
    constructor(props) {
        super(props);
        this.state = { 
            response: [],
            error: [],
            key: 0,
            security: cookie.load('userBulletin')
          }
      }

    componentWillMount() {
        if (this.state.security === undefined) 
        {  
          this.setState({security: {sUsuEmail: ' Sin correo ' , nUsuCodigo: 0, sUsuNombre: 'Invitado', sUsuApellidoPaterno: ' ' }}, 
            ()=> {
                cookie.save("userBulletin", this.state.security);
            });
        } else {
            cookie.save("userBulletin", this.state.security);
        }
    }

    render() {        
        return ( 
        <div>
            <nav className="fixed-top navbar navbar-expand navbar-light">
                <div className="container navbar__all-options">
                <div className="navbar-brand">
                    <ul id="boletin__header-title">
                        <li className="boletin__logo">
                            <a href="#">
                            <img src="/img/header_png.png" />
                            </a>
                        </li>
                        {/* <li className="boletin__logo">
                            <a href="#">
                            <img src="/img/logoPP.png" width="90px" />
                            </a>
                        </li> */}
                        <li hidden={true} className="boletin__category boletin__category--web">
                            <span className="boletin__category--pl"><strong>Boletín de inteligencia</strong></span>
                        </li>
                    </ul>
                </div>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarsOptions"
                    aria-controls="navbarsOptions"
                    aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarsOptions">
                    <form className="boletin__search-form form-inline my-2 my-md-0  ml-auto" hidden={true}>
                    <div className="input-group">
                        <input
                        className="boletin__search form-control py-2"
                        type="search"
                        placeholder="Buscar en este boletín"/>
                        <span className=" input-group-append">
                        <div className="boletin__search--btn input-group-text bg-transparent">
                            <i className="fa fa-search"></i>
                        </div>
                        </span>
                    </div>
                    </form>
                    <div hidden={true} className="searchbar--mobile d-flex justify-content-center">
                        <div className="searchbar">
                        <input className="search_input " type="text" name="" placeholder=""/>
                            <a href="#" className="search_icon"><i className="fas fa-search"></i></a>
                        </div>
                    </div>
                    
                    <ul className="menu__all-info-user nav navbar-nav" hidden={true}>
                    <li className="nav-item dropdown no-arrow">
                        <div className="menu__user">
                        <a
                            href="#"
                            id="userDropdown"
                            role="button"
                            className="menu__notifications text-center d-none d-lg-block">
                            <img className="menu__user-img rounded-circle"src="/img/avatar6.png" />
                            {/* <span className="menu__user-counter"></span> */}
                        </a>
                        <div className="menu__user-info">
                            <a className="user">Hola, {this.state.security.sUsuNombre}  {this.state.security.sUsuApellidoPaterno} </a>
                            <div className="email">{this.state.security.sUsuEmail}</div>
                        </div>
                        </div>
                    </li>
                    </ul>
                </div>
                </div>
            </nav>
        </div>)
    }

}